export default {
  // 导航菜单
  nav: {
    home: 'Home',
    store: 'Products',
    about: 'About Us',
    news: 'News',
    applications: 'Applications',
    contact: 'Contact'
  },
  // 语言切换
  language: {
    switch: 'Language',
    chinese: '中文',
    english: 'English'
  },
  // 英雄区域
  hero: {
    title: '自然无忧',
    subtitle: 'Providing you with pure natural and pollution-free quality products for a healthier and better life',
    viewNow: 'View Now',
    learnMore: 'Learn More'
  },
  // 产品区域
  store: {
    title: 'Product Introduction',
    subtitle: 'Selected high-quality natural products to escort your healthy life',
    viewNow: 'View Now',
    currency: '$'
  },
  // 产品特点
  features: {
    title: 'Product Features',
    subtitle: 'Core advantages of Natural Worry-Free series products',
    feature1: {
      title: 'Natural & Eco-friendly',
      description: 'Made from plant fiber materials, completely biodegradable and pollution-free'
    },
    feature2: {
      title: 'Hygienic & Safe',
      description: 'Single-use design prevents cross-contamination and ensures hygiene safety'
    },
    feature3: {
      title: 'Comfortable & Convenient',
      description: 'Thickened pearl pattern spunlaced non-woven fabric, comfortable touch and convenient use'
    },
    feature4: {
      title: 'Wide Application',
      description: 'Suitable for hotels, hospitals, beauty salons, nursing homes and other venues'
    }
  },
  // 关于我们
  about: {
    title: 'About Us',
    subtitle: 'About us',
    content: 'The Natural Worry-Free series products are managed by Gangshenglannin. The raw materials are made of plant fiber (thickened pearl pattern spunlaced non-woven fabric) processed into disposable bed sheets, quilt covers, pillowcases, bath towels and face towels, etc. We can provide OEM/ODM branding processing services, suitable for hotels, hospitals, beauty salons, nursing homes, high-end B&Bs and other fields. We are committed to production and environmental protection practices, using environmentally friendly materials that can be completely naturally degraded. Our products are natural, high-quality, hygienic and safe, aiming to provide users with a healthier, more comfortable and environmentally friendly experience.'
  },
  // 新闻区域
  news: {
    title: 'Latest Company News',
    subtitle: 'News Center',
    empty: 'No blog posts have been published yet.',
    readMore: 'Read More'
  },
  // 应用场景
  applications: {
    title: 'Product Application Scenarios',
    subtitle: 'Disposable bed sheets and quilt covers are suitable for various places: hotels, hospitals, camping, and home apartments',
    travel: {
      title: 'Travel and Camping',
      description: 'Using disposable bed sheets and quilt covers during travel and camping is a wise choice. They are lightweight and easy to carry, can be used anywhere, and you don\'t have to worry about cleaning and maintenance. Disposable bed sheets and quilt covers can also reduce luggage weight and improve the convenience of travel and camping.'
    },
    hotel: {
      title: 'Hotels and Inns',
      description: 'Hotels and inns using disposable bed sheets and quilt covers can ensure that guests get clean bedding every time they check in, while also facilitating hotel cleaning work. Disposable bed sheets and quilt covers can also reduce washing costs and time, improving hotel efficiency.'
    },
    home: {
      title: 'Home and Apartment Rental',
      description: 'Using disposable bed sheets and quilt covers in home and apartment rentals can ensure that guests get clean bedding and reduce cleaning and maintenance workload. Disposable bed sheets and quilt covers can also improve the hygiene standards of rental properties and increase customer satisfaction.'
    },
    medical: {
      title: 'Hospitals and Clinics',
      description: 'Hospitals and clinics using disposable bed sheets and quilt covers can ensure the hygiene and safety of hospital beds and reduce the risk of cross-infection. Disposable bed sheets and quilt covers can also reduce cleaning costs and time, improving the efficiency of medical facilities.'
    },
    summaryTitle: 'All these places need to provide clean and hygienic bedding, and disposable bed sheets and quilt covers can meet this need well.',
    summaryDescription: 'Natural Worry-Free disposable bed sheets and quilt covers have wide applications in different places, providing users with clean and hygienic bedding while improving the efficiency and hygiene standards of various places.'
  },
  // 联系我们
  contact: {
    title: 'Contact Us',
    subtitle: 'We look forward to getting in touch with you',
    address: 'Address',
    addressText: 'Huaxia Guangda Baihua Industrial Park, No. 88 Taixiang Road, Taiyangao Industrial Zone, Baihua Town, Huidong County, Huizhou City, Guangdong Province',
    phone: 'Phone',
    phoneText: '400-123-4567',
    email: 'Email',
    emailText: 'lixltd@qq.com',
    form: {
      name: 'Your Name',
      email: 'Your Email',
      phone: 'Your Phone',
      message: 'Your Message',
      submit: 'Send Message',
      submitting: 'Sending...',
      validation: 'Please fill in name, email and message',
      emailInvalid: 'Please enter a valid email format',
      phoneInvalid: 'Please enter a valid phone number format'
    },
    submitSuccess: 'Thank you for your message, we will contact you as soon as possible!',
    submitError: 'Failed to send, please try again later'
  },
  // 页脚
  footer: {
    company: 'Huizhou Lixing Daily Products Co., Ltd.@ 2021',
    aboutUs: 'About Us',
    ourConcept: 'Our Concept',
    ourHistory: 'Our History',
    contactUs: 'Contact Us',
    phone: 'Phone: 400-000-1317',
    email: 'EMAIL: 1620294866@qq.com',
    viewIntroduction: 'View Introduction'
  }
}
